<template>
    <div>
        <div style="display: flex;justify-content: space-between;margin-bottom: 10px;">
            <div>
                <el-radio-group v-model="regStatus" size="mini" @input="inputChange">
                    <el-radio-button label="1">参会人员</el-radio-button>
                    <el-radio-button label="2">会议请假</el-radio-button>
                    <!-- <el-radio-button label="0">未回执</el-radio-button> -->
                </el-radio-group>
            </div>
            <div v-if="regStatus==1">
                <el-button v-if="isAddPeople" style="font-size: var(--portalFontSize13);" type="primary" size="mini" @click="addClick">添加外部人员</el-button>
                <el-button v-if="isAddPeople" v-select-dialog="'staff'" style="font-size: var(--portalFontSize13);" type="primary" size="mini">添加内部人员</el-button>
                <el-button style="font-size: var(--portalFontSize13);" size="mini" @click="hzExport">导出</el-button>
            </div>
            <div v-if="regStatus==2">
                <el-button v-if="isAddPeople" style="font-size: var(--portalFontSize13);" type="primary" size="mini" @click="hyqj">会议请假</el-button>
            </div>
        </div>
        <div>
            <el-table ref="table" :data="tableData" border class="jxzb-tables">
                <el-table-column type="index" :label="$tx('fields.index', '序号')" width="50" align="center"></el-table-column>
                <el-table-column prop="personName" label="人员类型" width="130" align="center" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <div>{{ scope.row.personType==1?'内部人员':'外部人员' }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="userName" label="姓名" width="130" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="userPost" label="职务" width="120" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="userDept" label="部门" width="150" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="phone" label="电话" width="130" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column v-if="regStatus==2" prop="regReason" :label="'拒绝原因'" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column v-else prop="remark" :label="'备注'" align="center" :show-overflow-tooltip="true"></el-table-column>
                <!-- <el-table-column v-if="regStatus!=2" prop="updateType" label="附件数" width="100" align="center" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <div>{{ scope.row.passenger.attachments?scope.row.passenger.attachments.length:0 }}</div>
                    </template>
                </el-table-column> -->
                <el-table-column v-if="regStatus==1&&canEdit" prop="updateContent" label="操作" width="130" align="center">
                    <template slot-scope="scope">
                        <el-link :underline="false" @click="delClick(scope.row)">删除</el-link>
                        <el-link :underline="false" @click="editClick(scope.row)">修改</el-link>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog
        v-if="isShow"
v-el-drag-dialog append-to-body title="
会议请假" :visible.sync="isShow" :close-on-click-modal="false" width="1000px"
>
            <el-form ref="changeForm" :model="replayVo" style="margin: 10px 0px; text-align: center">
                <div class="el-table el-table--fit el-table--border">
                    <div class="el-table__body-wrapper">
                        <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                            <tbody>
                                <tr key="radio">
                                    <td class="el-table__cell tdlbl tdw17">
                                        <span class="required"></span>
                                        <span v-field-lbl="'substitutePersonnel'">替会人员</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                        <el-input v-model="replayVo.dmeetName" v-select-dialog="'staff'" type="input" multiple="false" :root-org-code="loginUser.orgCode" name="recUser" :placeholder="$tx('hygl.components.substitutePersonnelPlaceholder', '请选择替会人员')">
                                        </el-input>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="el-table__cell tdlbl tdw17">
                                        <span class="required">*</span>
                                        <span v-field-lbl="'notAttendingReason'">不参会原因</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw83" colspan="5">

                                         <el-input v-model="replayVo.regReason" type="textarea" :placeholder="$tx('hygl.components.notAttendingReasonPlaceholder', '请输入不参会原因')" />

                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </el-form>
            <!-- <button v-show="anniu" v-select-dialog="'staff'" class="xzry" multiple="true" :root-org-code="loginUser.orgCode" name="Share"></button> -->
            <span slot="footer" class="dialog-footer">
                <el-button v-pageBtn-lbl="'close'" :icon="'el-icon-close'" @click="isShow=false">关 闭</el-button>
                <el-button v-pageBtn-lbl="'submit'" type="primary" :icon="'el-icon-check'" @click="SignforConfirm">提 交</el-button>
            </span>
        </el-dialog>
        <Basicform
        v-if="showForm"
        title="参会人员"
        :win-width="moduleInfo.winWidth"
        :win-height="moduleInfo.winHeight"
        :append-to-body="true"
        :toolbar-btns="busiformBtns"
      >
        <template #default="slotProps">
          <busi-form ref="hyyt" :vo="slotProps.vo" :can-edit="slotProps.canEdit" :module-info="moduleInfo" />
        </template>
      </Basicform>
    </div>
</template>

<script>
const moment = require('moment')
export default {
    filters: {
        timeFormat(val) {
            return moment(val).format('YYYY-MM-DD HH:mm')
        }
    },
    components: {},
    props: {
        row: {
            type: Object,
            default: () => {}
        },
        canEdit: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            loginUser: this.$store.getters.loginUser,
            isShow: false,
            replayVo: {},
            isAddPeople: true,
            dialogVisible: false,
            showForm: false,
            tableData: [],
            regStatus: 1,
            busiformBtns: [],
            moduleInfo: {
                formTemplate: 'dcontent/busiformurl?vwtype=W&url=/hygl/meetPeople/form.html',
                winWidth: 1200,
                delUrl: '/hygl/meetPeople/delete',
                addNewUrl: '/hygl/meetPeople/addNew',
                insertUrl: '/hygl/meetPeople/insert',
                moduleCode: 'meetPeople',
                winHeight: 600,
                updateUrl: '/hygl/meetPeople/update',
                listDataUrl: '/hygl/meetPeople/listdata',
                getByIdUrl: '/hygl/meetPeople/getById'
            }
        }
    },
    computed: {},
    watch: {},
    created() {
        this.$bus.on('meetInfoFourth', this.meetInfoFourth)
        this.meetInfoFourth()
        if (this.row.receiptEndTime) {
            let nowTime = moment(new Data()).format('YYYY-MM-DD HH:mm:ss')
            if (nowTime > this.row.receiptEndTime) {
                this.isAddPeople = false
            }
        }
    },
    beforeDestroy() {
        this.$bus.off('meetInfoFourth', this.meetInfoFourth)
    },
    mounted() {},
    methods: {
        //会议请假
        hyqj() {
            this.isShow = true
        },
        //会议请假保存
        SignforConfirm() {
            var _this = this
            this.$set(this.replayVo, 'regStatus', 2)
            this.$set(this.replayVo, 'meetId', this.row.id)
            this.$set(this.replayVo, 'personId', this.loginUser.personId)
            this.$refs.changeForm.formValidate(async (isOk) => {
                if (!this.replayVo.regReason) {
                    _this.$alert(_this.$tx('hygl.message.reasonNeed', '不参会原因是必须的'), _this.$tx('common.operationTip', '操作提示'), {
                        type: 'warning'
                    })
                    return
                }

                _this
                    .$http({
                        method: 'PUT',
                        url: '/hygl/meetPeople/updateTurnSend',
                        data: _this.replayVo
                    })
                    .then((res) => {
                        console.log(999, res)
                        if (res.code === 'success') {
                            _this.isShow = false
                            _this.replayVo = {}
                            // console.log('会议回执提交')
                            this.getTableData()
                            _this.$message.success(res.message)
                        } else {
                            _this.$message.error(res.message)
                        }
                    })
            })
        },
        onSelectStaffCompleted(node, attr) {
            if (attr.name === 'recUser') {
                debugger
                this.replayVo.dmeetName = node[0].name
                this.replayVo.dmeetId = node[0].personId
            } else {
                this.$http({
                    method: 'post',
                    url: '/hygl/meetPeople/addNew'
                }).then(res => {
                    if (res.code === 'success') {
                        let vo = res.body.vo
                        vo.personType = 1
                        vo.userName = node[0].name
                        vo.userId = node[0].personId
                        vo.personId = node[0].personId
                        vo.userAccount = node[0].account
                        vo.phone = node[0].mobile
                        vo.userDept = node[0].orgFullName.split('-')[node[0].orgFullName.split.length - 1]
                        vo.orgFullId = node[0].orgFullId
                        vo.userPost = node[0].positionName
                        vo.orgFullOrderNo = node[0].orgFullOrderNo

                        vo.meetId = this.row.id
		            vo.regStatus = 1

                        this.$http({
                            method: 'post',
                            url: '/hygl/meetPeople/insert',
                            data: vo
                        }).then(res => {
                            if (res.code === 'success') {
                                this.$message.success('添加成功')
                                this.getTableData()
                            } else {
                                this.$message.warning(res.message)
                            }
                        })
                    }
                })
            }
        },
        meetInfoFourth() {
            this.getTableData()
        },
        getTableData() {
            this.$http({
                method: 'post',
                url: '/hygl/meetPeople/listdata',
                params: {
                    pageSize: 9999,
                    pageNum: 1,
                    urlsearch: `meetId:${this.row.id};regStatus:${this.regStatus};meetPersonType!:4`
                }
            }).then(res => {
                if (res.code === 'success') {
                    this.tableData = res.body.pageInfo.list
                }
            })
        },
        addClick() {
            this.moduleInfo.formTemplate = '#/dcontent/vuebusiform/W/hygl.meetPeople.form.vue?sysCode=' + this.$route.meta.sysCode
            this.$options.components['BusiForm'] = this.$loadComponent(this.moduleInfo.formTemplate)
            this.showForm = true
            this.moduleInfo.row = this.row
            this.$nextTick(() => {
                this.$bus.emit('openBusiform', this.moduleInfo, null, 1, (res) => {
                    if (res.code === 'success') {
                        this.$message.success('保存成功')
                        this.getTableData()
                    }
                    delete this.moduleInfo.row
                    this.showForm = false
                })
            })
        },
        editClick(row) {
            this.moduleInfo.formTemplate = '#/dcontent/vuebusiform/W/hygl.meetPeople.form.vue?sysCode=' + this.$route.meta.sysCode
            this.$options.components['BusiForm'] = this.$loadComponent(this.moduleInfo.formTemplate)
            this.showForm = true
            this.$nextTick(() => {
                this.$bus.emit('openBusiform', this.moduleInfo, row, 1, (res) => {
                    if (res.code === 'success') {
                        this.$message.success('保存成功')
                        this.getTableData()
                    }
                    this.showForm = false
                })
            })
        },
        delClick(row) {
            this.$confirm('您是否确认删除此参会人员？', this.$tx('common.confirmOperate', '确认操作'), { type: 'warning' }).then(async () => {
                const res = await this.$app.deleteByIds(this.moduleInfo.delUrl, [row.id])
                if (res.code === 'success') {
                    this.$message.success(res.message)
                    this.getTableData()
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        inputChange(val) {
            this.getTableData()
        },
        hzExport() {
            const headerAlias = {
                'personType': '人员类型',
                'userName': '姓名',
                'userPost': '职务',
                'userDept': '部门',
                'phone': '电话',
                'remark': '备注'

            }

            console.log('JSON.stringify(headerAlias)', JSON.stringify(headerAlias))
            window.open(`/apigw/hygl/meetPeople/dynamicExportData?pageNum=1&pageSize=9999&urlsearch=meetId:${this.row.id};regStatus:${this.regStatus}&headerAlias=${encodeURIComponent(JSON.stringify(headerAlias))}&fileName=${encodeURIComponent('参会人员.xlsx')}`)
        },
        // 关闭
        toClose() {
            this.dialogVisible = false
        }
    }
}
</script>

<style scoped lang="scss">
.dialog_top {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    .el-button {
        margin-left: 10px;
        padding: 8px 15px;
    }
}
</style>
